import AuthService from '../service/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initalState = user
    ? { status: { loggedIn: true }, user }
    : { status: { loggedIn: false }, user: null };

export const auth = {
    namespaced: true,
    state: initalState,
    actions: {
        login({ commit }, user) {
            return AuthService.funLogin(user).then(
                user => {
                    commit('loginSuccess', user);
                    let message = `Chào mừng bạn đã quay trở lại`;
                    const data = {
                        status: 1,
                        type: 'login',
                        user: user,
                        message: message
                    }
                    return Promise.resolve(data);
                },
                error => {
                    commit('loginFail');
                    const data = {
                        status: 0,
                        type: 'login',
                        code: error.response?.data?.status, // 428 = tài khoản bật 2FA, cần nhập mã
                        message: error.response?.data?.errors
                    }
                    return Promise.resolve(data);
                }
            );
        },
        loginKeycloak({ commit }, { accessToken, idToken }) {
            return AuthService.funLoginKeycloak(accessToken, idToken).then(
                user => {
                    commit('loginSuccess', user);
                    return { status: 1, type: 'login', user: user, message: `Chào mừng bạn đã quay trở lại` };
                },
                error => {
                    commit('loginFail');
                    return { status: 0, type: 'login', message: error.response?.data?.errors };
                }
            );
        },
        rigister({ commit }, user) {
            return AuthService.funRigister(user).then(
                user => {
                    commit('rigisterSuccess', user);
                    let message = `Chúc mừng đã đăng ký thành công`;
                    const data = {
                        status: 1,
                        type: 'rigister',
                        user: user,
                        message: message
                    };
                    return Promise.resolve(data);
                },
                error => {
                    commit('rigisterFail');
                    const data = {
                        status: 0,
                        type: 'rigister',
                        message: error.response.data
                    }
                    return Promise.resolve(data);
                }
            )
        }
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFail(state) {
            state.status.loggedIn = true;
            state.user = null;
        },
        rigisterSuccess(state, user) {
            state.status.rigisterIn = true;
            state.user = user;
        },
        rigisterFail(state) {
            state.status.rigisterIn = false;
            state.user = null;
        }
    }
}